/* eslint-disable   */
import React from "react";

export default function footer() {
  return (
    <div className="footer  ">
      <a href="https://twitter.com/willsouza" rel="noopener" target="_blank">
        @willsouza
      </a>
    </div>
  );
}
